export const segmentOptions = [
  { value: 'Varejo/Loja', text: 'Varejo/Loja' },
  { value: 'Oficina', text: 'Oficina' },
  { value: 'Atacadista', text: 'Atacadista' },
  { value: 'Ecommerce', text: 'Ecommerce' },
];

export const productsOptions = [
  { value: 'Kit Titanium', text: 'Kit Titanium' },
  { value: 'Kit Top (c/ retentor)', text: 'Kit Top (c/ retentor)' },
  { value: 'Buzina', text: 'Buzina' },
  { value: 'Corrente de comando', text: 'Corrente de comando' },
  { value: 'Pedal de partida', text: 'Pedal de partida' },
  { value: 'Caixa de direção', text: 'Caixa de direção' },
  { value: 'Semi Kit Riffel Carbon', text: 'Semi Kit Riffel Carbon' },
  { value: 'Rolamentos', text: 'Rolamentos' },
];

export const serviceOptions = [
  { value: 'Telefone', text: 'Telefone' },
  { value: 'WhatsApp', text: 'WhatsApp' },
  { value: 'E-mail', text: 'E-mail' },
];
